<!--
 * @Author: ���� 371824572@qq.com
 * @Date: 2024-06-27 09:58:30
 * @LastEditors: ���� 371824572@qq.com
 * @LastEditTime: 2024-07-15 10:07:06
 * @FilePath: \frontend\src\views\PublicParams\PublicParams.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <section>
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
  
      <!--列表-->
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        style="width: 100%" class="custom-tbl">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" width="80"></el-table-column>
        <el-table-column prop="Name" label="参数名" width="230" sortable></el-table-column>
        <el-table-column prop="Value" label="参数值" width="230" sortable></el-table-column>
        <el-table-column prop="Describe" label="描述" width sortable></el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width sortable></el-table-column>
        <el-table-column prop="CreateBy" label="创建者" width="" sortable>
        </el-table-column>
  
        <el-table-column prop="ModifyTime" label="修改时间" :formatter="formatModifyTime" width sortable></el-table-column>
        <el-table-column prop="ModifyBy" label="修改人" width="" sortable>
        </el-table-column>
      </el-table>
  
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total"
          style="float: right"></el-pagination>
      </el-col>
  
      <!--编辑界面-->
      <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
          <el-form-item label="参数名" prop="Name">
            <el-input disabled v-model="editForm.Name"  auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="参数值" prop="Value">
            <el-input  v-model="editForm.Value" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="Describe">
            <el-input v-model="editForm.Describe" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>
  
      <!--新增界面-->
      <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
            <el-form-item label="参数名" prop="Name">
            <el-input  v-model="addForm.Name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="参数值" prop="Value">
            <el-input  v-model="addForm.Value" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="Describe">
            <el-input v-model="addForm.Describe" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </template>
  
  <script>
  import util from "../../../util/date";
  import {
    getRoleListPage,
    removeRole,
    editRole,
    addRole,
    getDepartmentTree,
  } from "../../api/api";
  import {
    GetPublicParamsLs,
    DeletePublicParamsByIds,
    AddPublicParams,
    PutPublicParams
  } from "../../api/PublicParams/PublicParams";
  import { getButtonList } from "../../promissionRouter";
  import Toolbar from "../../components/Toolbar";
  
  export default {
    components: { Toolbar },
    data () {
      return {
        filters: {
          name: "",
        },
        buttonList: [],
        options: [],
        users: [],
        Enabled: true,
        defaultProps: {
          children: "children",
          label: "label",
        },
        total: 0,
        page: 1,
        listLoading: false,
        sels: [], //列表选中列
        currentRow: null,
        addDialogFormVisible: false,
        editFormVisible: false, //编辑界面是否显示
        editLoading: false,
        editFormRules: {
          Name: [{ required: true, message: "请输入参数名", trigger: "blur" }],
          Value: [{ required: true, message: "请输入参数值", trigger: "blur" }],
        },
        //编辑界面数据
        editForm: {
          Id: 0,
          CreateBy: "",
          Name: "",
          Value: "",
          Describe: "",
        },
  
        addFormVisible: false, //新增界面是否显示
        addLoading: false,
        addFormRules: {
          Name: [{ required: true, message: "请输入参数名", trigger: "blur" }],
          Value: [{ required: true, message: "请输入参数值", trigger: "blur" }],
        },
        //新增界面数据
        addForm: {
          CreateBy: "",
          CreateId: "",
          Name: "",
          Describe: "",
          Value: "",
        },
        isResouceShow: 0,
      };
    },
    computed: {
    },
    methods: {
      dialogCheck (selection, row) {
        this.currentRow = null;
        this.$refs.table.clearSelection();
        if (selection.length === 0) {
          return;
        }
        if (row) {
          this.selectCurrentRow(row);
        }
      },
      selectCurrentRow (val) {
        if (val) {
          this.currentRow = val;
          this.$refs.table.clearSelection();
          this.$refs.table.toggleRowSelection(val, true);
        }
      },
      callFunction (item) {
        this.filters = {
          name: item.search,
        };
        this[item.Func].apply(this, item);
      },
      formatCreateTime: function (row, column) {
        return !row.CreateTime || row.CreateTime == ""
          ? ""
          : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd hh:mm:ss");
      },
      formatModifyTime: function (row, column) {
        return !row.ModifyTime || row.ModifyTime == ""
          ? ""
          : util.formatDate.format(
            new Date(row.ModifyTime),
            "yyyy-MM-dd hh:mm:ss"
          );
      },
      handleCurrentChange (val) {
        this.page = val;
        this.getPublicParams();
      },
      //获取用户列表
      getPublicParams () {
        let _this = this;
        let para = {
          page: this.page,
          key: this.filters.name,
        };
        this.listLoading = true;
        //NProgress.start();
        GetPublicParamsLs(para).then((res) => {
          this.total = res.data.response.dataCount;
          this.users = res.data.response.data;
          this.listLoading = false;
          //NProgress.done();
        });
      },
      //删除
      handleDel () {
        let row = this.currentRow;
        if (!row) {
          this.$message({
            message: "请选择要删除的一行数据！",
            type: "error",
          });
  
          return;
        }
        this.$confirm("确认删除该记录吗?", "提示", {
          type: "warning",
        })
          .then(() => {
            this.listLoading = true;
            //NProgress.start();
            let para = { id: row.Id };
            DeletePublicParamsByIds(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.listLoading = false;
                return;
              }
              this.listLoading = false;
              //NProgress.done();
              if (res.data.success) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.currentRow = null; // Clear current row selection
                this.getPublicParams();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          })
          .catch(() => { });
      },
      //显示编辑界面
      handleEdit () {
        let row = this.currentRow;
        this.options = [];
        if (!row) {
          this.$message({
            message: "请选择要编辑的一行数据！",
            type: "error",
          });
  
          return;
        }
        this.editFormVisible = true;
        this.editForm = Object.assign({}, row);
      },
      //显示新增界面
      handleAdd () {
        this.addFormVisible = true;
        this.options = [];
        this.addForm = {
            CreateBy: "",
            CreateId: "",
            Name: "",
            Describe: "",
            Value: "",
        };
  
      },
      //编辑
      editSubmit: function () {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);
  
  
              PutPublicParams(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
  
                if (res.data.success) {
                  this.editLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.currentRow = null;
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.getPublicParams();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                  this.currentRow = null;
                }
              });
            });
          }
        });
      },
      //新增
      addSubmit: function () {
        let _this = this;
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              AddPublicParams(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.addLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getPublicParams();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                  this.addLoading = false;
                }
              }).catch((error) => {
                console.log("添加失败")
                this.$refs["addForm"].resetFields();
                this.addLoading = false;
                this.$message({
                  message: error.message || '添加参数失败，请重试',
                  type: "error",
                });
  
              });
            });
          }
        });
      },
      getButtonList2 (routers) {
        let _this = this;
        routers.forEach((element) => {
          let path = this.$route.path.toLowerCase();
          if (element.path && element.path.toLowerCase() == path) {
            _this.buttonList = element.children;
            return;
          } else if (element.children) {
            _this.getButtonList(element.children);
          }
        });
      },
    },
    mounted () {
      this.getPublicParams();
  
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      //第一种写法，每个页面都需要写方法，但是可以做特性化处理
      // this.getButtonList(routers);
  
      //第二种写法，封装到 permissionRouter.js 中
      this.buttonList = getButtonList(this.$route.path, routers);
    },
  };
  </script>
  
  <style scoped>
  .custom-tbl /deep/ .has-gutter .el-checkbox {
    display: none;
  }
  </style>
  